import template from './templates/recent-searches.tmpl.html';

export default function RecentSearches() {
    return {
        template,
        restrict: 'E',
        transclude: true,
        require: '?ngModel',
        scope: {
            searchResults: '=',
            caption: '&',
            choose: '&',
            isOpen: '=',
        },
        link: function(scope, element) {
            function read() {
                scope.choose()(scope.searchResults[scope.selectedIndex]);
            }

            scope.isActive = false;
            scope.selectedIndex = 0;
            const input = element.find('input');
            scope.$watch(() => input.val(), (newValue) => scope.isActive = (!!newValue.length && newValue.length < 3));

            input.on('click', function() {
                const searchResults = input.parent().find('.dropdown-menu');
                if (!angular.element(searchResults).is(':visible') && !input.val()) {
                    scope.isActive = true;
                    scope.$apply();
                }
            });


            angular.element(input).keydown((event) => {
                if (!scope.searchResults) {
                    return;
                }
                if (event.keyCode === 38) {
                    // up arrow
                    if (scope.selectedIndex > 0) {
                        scope.selectedIndex--;
                    } else {
                        scope.selectedIndex = scope.searchResults.length - 1;
                    }
                    scope.$apply();
                } else if (event.keyCode === 40) {
                    // down arrow

                    if (scope.selectedIndex < scope.searchResults.length - 1) {
                        scope.selectedIndex++;
                    } else {
                        scope.selectedIndex = 0;
                    }
                    scope.$apply();
                } else if (event.keyCode === 13 && scope.isOpen) {
                    // enter key
                    scope.$evalAsync(read);
                    event.preventDefault();
                }
            });

        },
    };
}



// WEBPACK FOOTER //
// ./src/app/directives/recentSearches.directive.js